import { Link } from "react-router-dom";
import { Heading, Text, Img } from "./..";
import React from "react";

export default function CaseStudyInfo({
  titleText = "How To Create Restaurant P&L Trend Analysis?",
  descriptionText = "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail....",
  statsIconText = "50",
  downloadIconText = "50",
  priceText = "300 EGP",
  ...props
}) {
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col w-[358px] gap-1 p-3 border-gray-100 border-[0.5px] border-solid bg-white-a700 rounded-[18px] sm:min-w-[358px]`}
    >
      <Link to="/casepage">
        <div className="self-stretch flex flex-col gap-1">
          <div className="flex items-center">
            <Img
              src="images/img_checkmark.svg"
              alt="Verified By"
              className="h-[16px]"
            />
            <Text as="p" className="self-end text-[12px] font-normal">
              <span className="text-gray-700">&nbsp;Verified by&nbsp;</span>
              <span className="text-orange-900">Suplyd</span>
            </Text>
          </div>
          <Heading
            as="h6"
            className="!font-avenirarabic lg:text-[16px] font-black leading-5"
          >
            {titleText}
          </Heading>
          <Text
            as="p"
            className="text-[12px] font-normal leading-4 tracking-[0.50px] !text-gray-900_02"
          >
            {descriptionText}
          </Text>
        </div>
      </Link>
      <div className="flex items-center justify-center self-stretch">
        <div className="flex flex-1 justify-center gap-1">
          <div className="flex items-center gap-1">
            <Img
              src="images/img_contrast.svg"
              alt="Image"
              className="h-[16px]"
            />
            <Text as="p" className="self-end text-[12px] font-normal">
              {statsIconText}
            </Text>
          </div>
          <div className="flex flex-1 items-center px-1">
            <Img
              src="images/img_download.svg"
              alt="Image"
              className="h-[16px]"
            />
            <Text as="p" className="self-end text-[12px] font-normal">
              {downloadIconText}
            </Text>
          </div>
        </div>
        <Heading
          as="h6"
          className="!font-avenirarabic text-[16px] font-black !text-orange-900"
        >
          {priceText}
        </Heading>
      </div>
    </div>
  );
}
